import { CurriculumTag } from "./CurriculumTag";
export default CurriculumTag;
